import classes from './AvailableMeals.module.css';
import MealItem from './MealItem/MealItem';
import Card from '../UI/Card';

const DUMMY_MEALS = [
  {
    id: 'm1',
    name: 'Chicken Dum Biryani',
    description: 'Finest Chicken with indian spices',
    price: 280.50,
  },
  {
    id: 'm2',
    name: 'Special Manchow Rice',
    description: 'A combination of fried noodles, rice with panner corn mushrooms',
    price: 210.15,
  },
  {
    id: 'm3',
    name: 'Panner Biryani Special',
    description: 'A fresh jalapenos, paneer - Made with indian spices',
    price: 250.00,
  },
  {
    id: 'm4',
    name: 'Deluxe Veg Pizza',
    description: 'Panner, Corn, Capsicum, Onion & Mushroom',
    price: 235.00,
  },
{
    id: 'm5',
    name: 'Chicken Roasted Pizza',
    description: 'Onion, Chicken, Oregano and Basil',
    price: 220.00,
  },
  {
    id: 'm6',
    name: 'BBQ Pizza',
    description: 'Onion, Mushroom, BBQ Chicken and Jalapenos',
    price: 260.50,
  },
  {
    id: 'm7',
    name: 'Barbecue Burger',
    description: 'American, raw, meaty',
    price: 190.10,
  },
  {
    id: 'm8',
    name: 'Green Bowl',
    description: 'Healthy...and green...',
    price: 140.00,
  },
{
    id: 'm9',
    name: 'Fruit and Nut Ice Cream',
    description: 'Dessert',
    price: 122.99,
  },
  {
    id: 'm10',
    name: 'Willy Wonkey Ice Cream',
    description: 'Dessert',
    price: 160.5,
  },
  {
    id: 'm11',
    name: 'Maggie Noodles',
    description: 'Favorite snack in India',
    price: 50.00,
  },
  {
    id: 'm12',
    name: 'Faluda with Icecream',
    description: 'Dessert',
    price: 60.00,
  }
  ];

const AvailableMeals = () => {
  const mealsList = DUMMY_MEALS.map((meal) => (<MealItem
    id={meal.id}
    key={meal.id}
    name={meal.name}
    description={meal.description}
    price={meal.price}
  ></MealItem>));
    return (
        <section className={classes.meals}>
          <Card>  <ul>
            {mealsList}
            </ul>
            </Card>
        </section>

    )
}
export default AvailableMeals;